import { ListBox, ListBoxToolbar, processListBoxData } from "@progress/kendo-react-listbox";
import { useEffect } from "react";

const ResourcesTab = ({ state, setState, selectedObjects, setSelectedObjects }) => {
  const selected_field = "selected";

  useEffect(() => {
    const selectedResourceNames = state.selectedResources.map((res) => res.resourceName);
    const newSelectedObjects = selectedObjects.filter((obj) =>
      selectedResourceNames.includes(obj.resourceName)
    );
    if (newSelectedObjects.length !== selectedObjects.length) {
      setSelectedObjects(newSelectedObjects);
    }
  }, [state.selectedResources]);

  const handleItemClick = (event, resources, connectedData) => {
    setState({
      ...state,
      [resources]: state[resources].map((item) => {
        if (item.resourceName === event.dataItem.resourceName) {
          item[selected_field] = !item[selected_field];
        } else if (!event.nativeEvent.ctrlKey) {
          item[selected_field] = false;
        }
        return item;
      }),
      [connectedData]: state[connectedData].map((item) => {
        item[selected_field] = false;
        return item;
      }),
    });
  };

  const handleToolBarClick = (e) => {
    let toolName = e.toolName || "";
    let result = processListBoxData(
      state.resources,
      state.selectedResources,
      toolName,
      selected_field
    );
    setState({
      ...state,
      resources: result.listBoxOneData,
      selectedResources: result.listBoxTwoData,
    });
  };

  return (
    <div className="k-d-flex !k-w-full">
      <div className="!k-w-1/5">
        <h3>Resources</h3>
        <ListBox
          style={{
            height: "400px",
            width: "100%",
          }}
          data={state.resources}
          size="large"
          textField="resourceName"
          selectedField={selected_field}
          onItemClick={(e) => handleItemClick(e, "resources", "selectedResources")}
          toolbar={() => {
            return GenericListBoxToolbar(state, handleToolBarClick);
          }}
        />
      </div>
      <div className="k-w-1/5 k-pl-2">
        <h3>Selected Resources</h3>
        <ListBox
          style={{
            height: "400px",
            width: "100%",
          }}
          size="large"
          data={state.selectedResources}
          textField="resourceName"
          selectedField={selected_field}
          onItemClick={(e) => handleItemClick(e, "selectedResources", "resources")}
        />
      </div>
    </div>
  );
};

export default ResourcesTab;

function GenericListBoxToolbar(state, handleToolBarClick) {
  return (
    <ListBoxToolbar
      tools={["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]}
      data={state.resources}
      dataConnected={state.selectedResources}
      onToolClick={handleToolBarClick}
    />
  );
}
